(function () {
    "use strict";
    angular.module("skillBuilderSaaS")
        .controller("InformationItemCtrl", ["learningPathVersionLocalizationResource", "messageService", "$translate", "$rootScope", "$scope", "$stateParams", "$localStorage", "$uibModal", "_", informationItemCtrl]);
    function informationItemCtrl(learningPathVersionLocalizationResource, messageService, $translate, $rootScope, $scope, $stateParams, $localStorage, $uibModal, _) {
        var vm = this;
        //Information Item Section
        //vm.number = $stateParams.number;
        //vm.version = $stateParams.version;
        vm.open = false;
        vm.showErrors = false;
        vm.loading = true;
        var lang = $translate.proposedLanguage() || $translate.use();
        lang = lang.replace("-", "_");
        vm.tinymceOptions = {
            resize: false,
            height: 300,
            plugins: "autoresize code",
            language: lang,
            convert_urls: 0
        };
        $scope.$on("toggleInfomationItemEdit", function (_event, args) {
            vm.loading = true;
            vm.open = !vm.open;
            if (vm.open) {
                vm.learningPathVersion = args;
                vm.number = vm.learningPathVersion.learningPathNumber;
                vm.version = vm.learningPathVersion.version;
                learningPathVersionLocalizationResource.get({ number: vm.number, version: vm.version }, function (result) {
                    vm.pathLocalizationInfoModel = result;
                    vm.indexPosition = result.informationDetails.indexOf(result.informationDetails[0]);
                    vm.selectedLocalizationId = parseInt($localStorage.currentLocalizationId);
                    vm.pathLocalizationInfoDetail = angular.copy(_.where(result.informationDetails, { localizationId: vm.selectedLocalizationId })[0]);
                    checkDetails();
                    copyOriginalDetail();
                    vm.loading = false;
                }, function (errorData) {
                    messageService.error(errorData);
                });
            }
        });
        vm.changeLocalization = function (localizationId) {
            if (vm.selectedLocalizationId !== localizationId) {
                if (!angular.equals(vm.pathLocalizationInfoDetailOriginal, vm.pathLocalizationInfoDetail)) {
                    var modal = $uibModal.open({
                        templateUrl: "unSavedDataWillBeLost.html",
                        backdrop: false,
                        animation: false,
                        windowClass: "confirmation-modal",
                        controller: ["$scope", function ($scope) {
                                var unSavedChangesVm = this;
                                unSavedChangesVm.dontSave = function () {
                                    changeLanguage(localizationId);
                                    $scope.$dismiss();
                                };
                            }],
                        controllerAs: "unSavedChangesVm"
                    });
                    modal.result.then(function () {
                        vm.save();
                        changeLanguage(localizationId);
                    }, function () {
                        $("#" + vm.selectedLocalizationId).focus();
                    });
                }
                else {
                    changeLanguage(localizationId);
                }
            }
        };
        function changeLanguage(localizationId) {
            vm.selectedLocalizationId = localizationId;
            vm.pathLocalizationInfoDetail = angular.copy(_.where(vm.pathLocalizationInfoModel.informationDetails, { localizationId: localizationId })[0]);
            checkDetails();
            copyOriginalDetail();
            vm.indexPosition = vm.pathLocalizationInfoModel.informationDetails.indexOf(vm.selectedDetailLocalization);
        }
        function copyOriginalDetail() {
            vm.pathLocalizationInfoDetailOriginal = angular.copy(vm.pathLocalizationInfoDetail);
        }
        function checkDetails() {
            if (!vm.pathLocalizationInfoDetail)
                vm.pathLocalizationInfoDetail = { name: null, content: null, isPublished: false };
        }
        vm.cancel = function () {
            $rootScope.$broadcast("toggleInfomationItemEdit");
        };
        vm.save = function () {
            if (vm.saving)
                return;
            if (vm.form.$valid) {
                vm.saving = true;
                vm.pathLocalizationInfoDetail.number = vm.number;
                vm.pathLocalizationInfoDetail.version = vm.version;
                vm.pathLocalizationInfoDetail.localizationId = vm.selectedLocalizationId;
                vm.pathLocalizationInfoDetail.versionId = vm.learningPathVersion.id;
                learningPathVersionLocalizationResource.save({ number: vm.number, version: vm.version }, vm.pathLocalizationInfoDetail, function (result) {
                    angular.extend(vm.pathLocalizationInfoModel, result);
                    vm.indexPosition = result.informationDetails.indexOf(result.informationDetails[0]);
                    vm.pageContent = angular.copy(_.where(result.informationDetails, { localizationId: vm.selectedLocalizationId })[0]);
                    copyOriginalDetail();
                    vm.saving = false;
                    messageService.success("learningPath.add.informationItemDetailSaved");
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            }
            else {
                vm.showErrors = true;
            }
        };
        vm.saveAndReturn = function () {
            if (vm.saving)
                return;
            if (vm.form.$valid) {
                vm.saving = true;
                vm.pathLocalizationInfoDetail.number = vm.number;
                vm.pathLocalizationInfoDetail.version = vm.version;
                vm.pathLocalizationInfoDetail.localizationId = vm.selectedLocalizationId;
                vm.pathLocalizationInfoDetail.versionId = vm.learningPathVersion.id;
                learningPathVersionLocalizationResource.save({ number: vm.number, version: vm.version }, vm.pathLocalizationInfoDetail, function (result) {
                    angular.extend(vm.pathLocalizationInfoModel, result);
                    vm.indexPosition = result.informationDetails.indexOf(result.informationDetails[0]);
                    vm.pageContent = angular.copy(_.where(result.informationDetails, { localizationId: vm.selectedLocalizationId })[0]);
                    copyOriginalDetail();
                    vm.saving = false;
                    messageService.success("learningPath.add.informationItemDetailSaved");
                    $rootScope.$broadcast("toggleInfomationItemEdit");
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            }
            else {
                vm.showErrors = true;
            }
        };
        //END Information Item Section
    }
}());
